// src/api/virtualCharacter.js
import axios from 'axios';

export default {
  /**
   * 获取我的虚拟对象
   * 注：根据后端逻辑，userId从Token中获取，无需前端传参
   */
  getMyCharacter() {
    return axios.get('/message/virtual/character/getVirtual');
  },

  /**
   * 创建虚拟对象
   * @param {Object} data - VirtualCharacterCreateDTO 对象
   */
  createCharacter(data) {
    return axios.post('/message/virtual/character/create', data);
  },

  /**
   * 更新虚拟对象信息
   * @param {Object} data - VirtualCharacterCreateDTO 对象
   */
  updateCharacter(data) {
    return axios.post('/message/virtual/character/update', data);
  }
};